import { render, staticRenderFns } from "./editChild.vue?vue&type=template&id=4f0c8fc8&scoped=true&"
import script from "./editChild.vue?vue&type=script&lang=js&"
export * from "./editChild.vue?vue&type=script&lang=js&"
import style0 from "./editChild.vue?vue&type=style&index=0&id=4f0c8fc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c8fc8",
  null
  
)

export default component.exports